module.exports = __webpack_public_path__ + "bb3.no1.874dfb6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb3.no1.jpg
// module id = SHiV
// module chunks = 0